<!-- tab选项 -->
<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleTabClick" class="publicTab" :before-leave="beforLeave">
      <el-tab-pane
        v-for="i in list"
        :key="i.name"
        :label="i.label"
        :disabled='i.disabled'
        :name="i.name"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    props: {
      list:{
        type:Array,
        default:()=>{ return [] }
      },
      beforLeave:[Function],
      nowTabVal:[String]
    },
    watch:{
      nowTabVal: {
        handler(val) {
          if(val) {
            console.log(val,this.activeName)
            if(val == this.activeName) return;
            this.activeName = val;
          }else {
            this.activeName = '1';
          }
        },
        immediate:true
      },
    },
    data() {
      return {
        activeName:""
      }
    },
    methods:{
      handleTabClick(e) {
       this.$emit('tabClick',e.name)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/tableTab.vue